import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, Building2, Heart, FileText } from 'lucide-react';

interface EmptyStateProps {
  type: 'dashboard' | 'favorites' | 'applications';
}

const content = {
  dashboard: {
    illustration: `data:image/svg+xml,${encodeURIComponent(`
      <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="140" height="140" rx="70" fill="#F3F4F6"/>
        <path d="M70 35L95 70L70 105L45 70L70 35Z" fill="#6366F1"/>
        <rect x="55" y="60" width="30" height="40" rx="4" fill="#4F46E5"/>
        <rect x="63" y="75" width="14" height="14" rx="2" fill="white"/>
        <path d="M70 50L80 65H60L70 50Z" fill="#4F46E5"/>
      </svg>
    `)}`,
    title: 'No Listings Yet',
    description: 'Start by creating your first property listing',
    actionText: 'Add New Listing',
    actionLink: '/add-listing',
    icon: Building2
  },
  favorites: {
    illustration: `data:image/svg+xml,${encodeURIComponent(`
      <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="140" height="140" rx="70" fill="#F3F4F6"/>
        <path d="M70 45C80 35 95 35 105 45C115 55 115 70 105 80L70 115L35 80C25 70 25 55 35 45C45 35 60 35 70 45Z" fill="#6366F1"/>
        <path d="M70 45C75 40 82.5 40 87.5 45C92.5 50 92.5 57.5 87.5 62.5L70 80L52.5 62.5C47.5 57.5 47.5 50 52.5 45C57.5 40 65 40 70 45Z" fill="#4F46E5"/>
        <rect x="50" y="70" width="40" height="30" rx="4" fill="#4F46E5"/>
        <rect x="58" y="80" width="24" height="10" rx="2" fill="white"/>
      </svg>
    `)}`,
    title: 'No Saved Properties',
    description: 'Save properties you like to view them later',
    actionText: 'Browse Listings',
    actionLink: '/listings',
    icon: Heart
  },
  applications: {
    illustration: `data:image/svg+xml,${encodeURIComponent(`
      <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="140" height="140" rx="70" fill="#F3F4F6"/>
        <rect x="35" y="35" width="70" height="70" rx="8" fill="#6366F1"/>
        <rect x="45" y="50" width="50" height="8" rx="4" fill="white"/>
        <rect x="45" y="65" width="40" height="8" rx="4" fill="#4F46E5"/>
        <rect x="45" y="80" width="30" height="8" rx="4" fill="#4F46E5"/>
        <circle cx="105" cy="95" r="15" fill="#4F46E5"/>
        <path d="M105 88V102M98 95H112" stroke="white" stroke-width="2" stroke-linecap="round"/>
      </svg>
    `)}`,
    title: 'No Applications Yet',
    description: 'Start browsing available properties and submit your first application',
    actionText: 'Browse Listings',
    actionLink: '/listings',
    icon: FileText
  }
};

const EmptyState: React.FC<EmptyStateProps> = ({ type }) => {
  const { illustration, title, description, actionText, actionLink, icon: Icon } = content[type];

  return (
    <div className="text-center py-12 px-4 bg-white rounded-lg shadow-sm">
      <div className="flex justify-center mb-6">
        <img
          src={illustration}
          alt=""
          className="w-36 h-36"
        />
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600 mb-6">{description}</p>
      <Link
        to={actionLink}
        className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 transition-colors"
      >
        <Plus className="h-5 w-5 mr-2" />
        {actionText}
      </Link>
    </div>
  );
};

export default EmptyState;